import React from "react";
import { Globe } from "lucide-react";
import { useTimezone } from "src/hooks/useTimezone";

interface CrossParticipantClocksProps {
  startTime: string;
  timezone: string;
  tutorTimezone: string;
  studentTimezone: string;
  isRecurring?: boolean;
}

export const CrossParticipantClocks: React.FC<CrossParticipantClocksProps> = ({
  startTime,
  timezone,
  tutorTimezone,
  studentTimezone,
  isRecurring = false,
}) => {
  const { formatTimeInTimezone } = useTimezone();

  return (
    <div className="p-4 rounded-xl bg-slate-50 border border-slate-200 space-y-2.5 font-sans">
      <div className="flex items-center justify-between text-xs font-semibold text-slate-700">
        <div className="flex items-center gap-1.5">
          <Globe className="w-4 h-4 text-purple-600" />
          <span>Cross-Participant Synchronized Clocks</span>
        </div>
        <span className="text-xs font-normal text-slate-500">
          {isRecurring ? "Consistent across all series dates" : "Auto-detected from profiles"}
        </span>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="p-2.5 rounded-lg bg-white border border-slate-200">
          <div className="text-xs font-semibold text-slate-500 uppercase">Dispatcher (You)</div>
          <div className="text-sm font-bold font-mono text-slate-900 mt-0.5">
            {startTime || "16:30"}
          </div>
          <div className="text-xs text-slate-500 truncate">{timezone}</div>
        </div>
        <div className="p-2.5 rounded-lg bg-white border border-slate-200">
          <div className="text-xs font-semibold text-purple-700 uppercase flex items-center justify-between">
            <span>Tutor Clocks</span>
            <span className="w-1.5 h-1.5 rounded-full bg-purple-600"></span>
          </div>
          <div className="text-sm font-bold font-mono text-purple-900 mt-0.5">
            {formatTimeInTimezone(new Date(), tutorTimezone)}
          </div>
          <div className="text-xs text-slate-500 truncate">{tutorTimezone}</div>
        </div>
        <div className="p-2.5 rounded-lg bg-white border border-slate-200">
          <div className="text-xs font-semibold text-blue-700 uppercase flex items-center justify-between">
            <span>Student Clocks</span>
            <span className="w-1.5 h-1.5 rounded-full bg-blue-600"></span>
          </div>
          <div className="text-sm font-bold font-mono text-blue-900 mt-0.5">
            {formatTimeInTimezone(new Date(), studentTimezone)}
          </div>
          <div className="text-xs text-slate-500 truncate">{studentTimezone}</div>
        </div>
      </div>
    </div>
  );
};

